import cx from 'classnames'
import Styles from './LinkedinPreview.module.scss'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'
import { MediaObject } from 'types'

export interface MediaLayoutProps {
  mediaObjects: MediaObject[]
  showVideoControls?: boolean
  videoFit?: 'contain' | 'cover'
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  isActive?: boolean
  isGenerating?: boolean
  onClose?: () => void
}

export const ImageGridMedia = ({ mediaObjects, ...mediaProps }: MediaLayoutProps) => (
  <div
    className={cx(Styles.imagesContainer, {
      [Styles.oneImage]: mediaObjects.length === 1,
      [Styles.threeImages]: mediaObjects.length === 3,
      [Styles.fourImages]: mediaObjects.length >= 4,
    })}
  >
    {mediaObjects.map((mediaObject, index) => {
      if (index > 3) return null
      const mediaUrl = mediaObject?.thumbnail_url || mediaObject?.source_url
      if (!mediaUrl) return null
      return (
        <div key={mediaUrl} className={Styles.imagePreviewContainer}>
          <MediaRenderer
            mediaObject={mediaObject}
            alt=""
            className={Styles.imagePreview}
            showVideoControls={mediaProps.showVideoControls}
            showHoverActionOverlay={mediaProps.showHoverActionOverlay}
            almanacFileKey={mediaProps.almanacFileKey}
            isActive={mediaProps.isActive}
            isPressable={!mediaProps.showHoverActionOverlay}
            isGenerating={mediaProps.isGenerating}
            onClose={mediaProps.onClose}
            allMediaObjects={mediaObjects}
          />
          {index === 3 && mediaObjects.length > 4 && (
            <div className={Styles.imageCountOverlay}>
              <span>+{mediaObjects.length - 4}</span>
            </div>
          )}
        </div>
      )
    })}
  </div>
)
